/*
 * SameHeight.js
 *
 * Makes some things the same height.. Simples.
 *
 * Use within $(document).ready - $('.some-selector').sameHeight();
 * You can choose the height method used - use one of "height", "innerHeight", or "outerHeight".
 * "outerHeight" is default. Example usage: $('.some-selector').sameHeight({heightMode: 'innerHeight'});
 *
 * Use with jquery.debouncedresize.js for responsive same heighting; e.g.
 * $(window).on("debouncedresize", function(event) {
 *   $('.some-selector').sameHeight();
 * });
 *
 * Copyright (C) 2015 Chris Street
 * Licensed under the GPL and MIT licenses.
 *
 * @version 1.0.0
 */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD (RequireJS); Register as an anonymous module
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        // CommonJS; for things like node.js, inc. Browserify
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {

    $.fn.sameHeight = function($options) {

        var $items = $(this),
            $largestHeight = 0,
            $defaults,
            $settings;

        // Run away if there is nothing to make the same height
        if ($items.length < 1) {
            return false;
        }

        // Set defaults for when options aren't provided.
        $defaults = {
            heightMode: 'outerHeight'
        };

        // Override the defaults with any user-defined options
        $settings = $.extend({}, $defaults, $options);

        // Run away if an invalid jQuery height method is defined.
        // For reference - height = height only, innerHeight = height + padding, outerHeight = height + padding + border
        if ($.inArray($settings.heightMode, ['innerHeight', 'outerHeight', 'height']) < 0) {
            console.log('Invalid heightMode option specified for sameHeights plugin. Use "innerHeight", "outerHeight", or "height".');
            return false;
        }

        // Set min height of each item to 0 to start with,
        $items.css('minHeight', 0);

        // Then for each item, loop through and ensure the value for the longest item is stored...
        $items.each(function() {
            if ($(this)[$settings.heightMode]() > $largestHeight) {
                $largestHeight = $(this)[$settings.heightMode]();
            }
        });

        // ...then set that value on all items!
        return $items.css('minHeight', $largestHeight);

    };

}));